/* Import Section - Start */
/* React Imports - Start */
import React, { useState, useEffect } from "react";
/* React Imports - End */

/* Plugin Imports - Start */
import { SelectButton } from "primereact/selectbutton";
import { useIsEdited } from "../../Providers/IsEditedProvider";
/* Plugin Imports - End */
/* Import Section - End */

/* Function - Start */
function SelectButtonElement(props) {
  /* State Declaration - Start */
  /* useState - Start */
  const [value, setValue] = useState(props.value);
  const { setIsEdited } = useIsEdited();
  /* useState - End */
  /* State Declaration - End */
  /* Methods - Start */
  const changeValue = (e) => {
    setIsEdited(true)
    setValue(e.value);
    props.onChangeSelect(e);
  };
  /* Methods - End */

  /* Render View Return - Start */
  return (
    <div className="">
      <SelectButton
        id={props.id}
        value={props.value}
        options={props.options}
        onChange={(e) => changeValue(e)}
        // optionLabel={props.optionlabel}
        className="flex h-27 select-button"
        register={props.register}
      />
    </div>
  );
  /* Render View Return - End */
}
/* Function - End */
/* Export default functionName; */
export default SelectButtonElement;
